import React, {useEffect, useState} from "react";
import useSerializedRefresh from "../../../useSerializedRefresh";
import ApiService from "../../../../../services/ApiService";
import ProgressBar from "@ramonak/react-progress-bar";
import {notification, Typography} from "antd";
import {uuidv4} from "../../../../../utils";
import {getDeviseSymbol} from "../../../../../i18n";

const {Text,Title}=Typography

export default function ScreenDonSection({context,campagneData,})
{
    const [loading,setLoading]=useState(true)
    const [dons,setDons]=useState([])

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:2 })

    const partnerMontant=campagneData?.partnerMontant || 1

    let donorName=campagneData.config?.donorName || "Parrainages"

    const screenOptions=campagneData?.screenOptions || {}


    const getDisplayName=(campagneExtraData={})=>{
        return campagneExtraData?.displayName || "Anonyme"
    }

    const getDons=async ()=>{
        let url="/campagne/donors/"+campagneData.id

        const res=await ApiService.get(url)
        let _dons=res.data

        if(screenOptions.minMontant){
            _dons=_dons.filter(i=>i.montant>=screenOptions.minMontant)
        }

        setDons(_dons)
        setLoading(false)
    }

    useSerializedRefresh(getDons, campagneData?._liveRevision)


    if(loading){
        return null
    }

    return (
        <div style={{overflow:"visible",width:"100%",height:"15vh",display:"flex",alignItems:"center",flexDirection:"row-reverse",gap:20,padding:"0 1.5vw"}}>
            {dons.map((d,index)=>{

                //console.log(index)

                let className="screen-don-card"

                if(index<4){
                    className+=" screenDonFadeIn"
                }else{
                    className+=" screenDonFadeOut"
                }

                //console.log(className)

                return(
                    <div style={{flexDirection:"column"}} key={d.id} className={className}>
                        <span style={{color:"#FFF",fontSize:"2.2vh",textAlign:"center"}}>{getDisplayName(d.campagneExtraData)}</span>
                        <span style={{color:"#FFF",fontSize:"3vh",textAlign:"center"}}>{formater.format(d.montant/partnerMontant)} {donorName}</span>
                    </div>
                )
            })}
        </div>
    )
}
